import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-ds-services',
    standalone: true,
    imports: [TranslateModule, CommonModule, SlickCarouselModule],
    templateUrl: './ds-services.component.html',
    styleUrl: './ds-services.component.scss',
})
export class DsServicesComponent {
    servicesData = [
        {
            img: 'assets/images/icons/target.png',
            title: 'DIGITAL_SERVICES.IMPROVED_EFFICIENCY_TITLE',
            desc: 'DIGITAL_SERVICES.IMPROVED_EFFICIENCY_DESC',
        },
        {
            img: 'assets/images/icons/reach.png',
            title: 'DIGITAL_SERVICES.MARKET_REACH_TITLE',
            desc: 'DIGITAL_SERVICES.MARKET_REACH_DESC',
        },
        {
            img: 'assets/images/icons/smart.png',
            title: 'DIGITAL_SERVICES.SMART_DECISION_TITLE',
            desc: 'DIGITAL_SERVICES.SMART_DECISION_DESC',
        },
        {
            img: 'assets/images/icons/engagement.png',
            title: 'DIGITAL_SERVICES.CUSTOMER_ENGAGEMENT_TITLE',
            desc: 'DIGITAL_SERVICES.CUSTOMER_ENGAGEMENT_DESC',
        },
    ];

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false,
                },
            },
        ],
    };
}
